import { FC } from 'react';
import { orderBy } from 'natural-orderby';
import SimpleSelect from '../../select/SimpleSelect';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { getNames } from 'src/common/utils/others';

interface IProps {
  check: boolean;
  className?: string;
  setLocation: (start: string | undefined, end: string) => void;
}

const AnotherLocation: FC<IProps> = ({ check, className, setLocation }) => {
  const {
    van: {
      filters: { location, end_location }
    },
    location: { locationList }
  } = useTypedSelector(state => state);

  const sortedLocation = orderBy(
    locationList,
    [location => location.country, location => location.name],
    ['asc', 'asc']
  );

  return (
    <div className={`filter__location ${className}`}>
      <SimpleSelect
        data={end_location && end_location.length ? end_location : 'Same'}
        setData={e => setLocation(location, e)}
        dataArrey={getNames(sortedLocation)}
        placeholder='Where?'
        notShowSelect
        title='End in'
        check={check}
      />
    </div>
  );
};
export default AnotherLocation;
